export enum ChartSeriesType {
  Bar = 'bar',
  Line = 'line',
}
